// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3viPF","row":"ProcedureTreatmentSummary_row__MdiKM"};